module.exports = __webpack_public_path__ + "img/pr-6.a0c96a3c.png";